<template>
<div class="register">
  <body
    class="account-page"
    style="font-family: 'CircularStd', sans-serif;
    font-size: .9375rem;
    color: #1f1f1f;
    background-color: #f7f7f7;
    min-height: 100%;
    overflow-x: hidden;"
  >
    <!-- Main Wrapper -->
    <div class="main-wrapper">
      <div class="account-content">
        <div class="container">
          <!-- Account Logo -->
          <div class="account-logo">
            <router-link to="/index">
              <img v-bind:src="logoText" :alt="appTitle" />
            </router-link>
          </div>
          <!-- /Account Logo -->

          <div class="account-box">
            <div class="account-wrapper">
              <!-- {{isSuccess}} -->
              <h3 class="account-title" v-if="isSuccess==false">Check Confirmation</h3>
              <h3 class="account-title" v-if="isSuccess==true">Create a New Password</h3>
              <!-- <p class="account-subtitle">Free &amp; No credit card required.</p> -->
              <!-- <div class="alert alert-danger" v-if="isError">{{msgError}}</div>
              <div class="alert alert-success" v-if="isSuccess">{{msgSuccess}}</div>-->
              <!-- /Account Form -->
              <form
                @submit.prevent="updatePasswordForgot"
                class="was-validated"
                v-if="isSuccess==true"
              >
                <div class="form-group">
                  <label>Password New</label>
                  <input
                    class="form-control"
                    type="password"
                    v-model="fieldsPass.member_password_new"
                    required
                  />
                </div>
                <div class="form-group">
                  <label>Repeat Password</label>
                  <input
                    class="form-control"
                    type="password"
                    v-model="fieldsPass.member_password_new_repeat"
                    required
                  />
                </div>
                <div class="form-group text-center">
                  <button
                    :disabled="isDisabled == 1"
                    class="btn btn-primary account-btn"
                    type="submit"
                  >Update</button>
                </div>
                <div class="account-footer">
                  <p>
                    Don't have an account yet?
                    <router-link to="/register">Register</router-link>
                  </p>
                </div>
              </form>
              <center>
                <button
                  :disabled="isDisabled"
                  @click="$router.push('/')"
                  class="btn btn-md"
                  type="submit"
                >&laquo; Back to Home</button>
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Main Wrapper -->
  </body>
</div>
</template>

<script>
export default {
  data() {
    return {
      isSuccess: false,
      isError: false,
      msgSuccess: "",
      msgError: "",
      appTitle: process.env.VUE_APP_TITLE,
      logoText: process.env.VUE_APP_LOGO_TEXT,
      isDisabled: 0,
      //   isProcessing: "",
      fieldsPass: {
        id: "",
        confirm_code: "",
        member_password_new: "",
        member_password_new_repeat: ""
      },
      fields: {
        id: "",
        confirm_code: ""
      }
    };
  },
  async created() {
    var id = await this.$route.query.id;
    var code = await this.$route.query.confirm_code;
    if (
      id != "" &&
      typeof id != "undefined" &&
      code != "" &&
      typeof code != "undefined"
    ) {
      this.fields.id = id;
      this.fields.confirm_code = code;
      this.checkForgot();

      this.fieldsPass.id = id;
      this.fieldsPass.confirm_code = code;
    } else {
      // console.log("not found!");
      this.$router.push("/");
    }
  },
  methods: {
    async updatePasswordForgot() {
      this.isDisabled = await 1;
      await this.$store
        .dispatch("forgot/updatePasswordForgot", this.fieldsPass) // sesuai kan dengan method di API
        .then(response => {
          console.log("response", response);
          var { data } = response;
          this.isSuccess = true;
          this.msgSuccess = response["msg"];
          if (response["status"] == 200) {
            this.$fire({
              title: "Success",
              text: response["msg"],
              type: "success",
              timer: 3000
            }).then(r => {
              this.isDisabled = 0;
              this.$router.push("/login");
            });
          }
        })
        .catch(error => {
          this.isDisabled = 0;
          this.$router.push("/");
        });
    },
    async checkForgot() {
      this.isDisabled = await 1;
      this.isSuccess = false;
      this.msgSuccess = "";
      this.isError = false;
      this.msgError = "";
      await this.$store
        .dispatch("forgot/checkForgot", this.fields) // sesuai kan dengan method di API
        .then(response => {
          console.log("response", response);
          var { data } = response;
          this.isSuccess = true;
          this.msgSuccess = response["msg"];
          if (response["status"] == 200) {
            this.$fire({
              title: "Success",
              text: response["msg"],
              type: "success",
              timer: 3000
            }).then(r => {
              this.isDisabled = 0;
            });
          }
        })
        .catch(error => {
          this.isDisabled = 0;
          // this.$router.push("/");
        });
    }
  },
  name: "forgotCheck"
};
</script>


// WEBPACK FOOTER //
// src/views/forgot/check.vue